/**
 * One id per user command. The local backend uses it to recognise a retry of a
 * command whose reply was lost after the write committed, so the money is not
 * booked twice. Allowed characters and length match the backend's check.
 */
export function createCommandId(): string {
  const webCrypto = globalThis.crypto as Crypto | undefined;
  if (typeof webCrypto?.randomUUID === 'function') {
    return webCrypto.randomUUID();
  }
  const random = () => Math.random().toString(36).slice(2, 10);
  return `${Date.now().toString(36)}-${random()}-${random()}`;
}
